import React, { useContext, useEffect, useState } from "react";
import { appContext } from "../../AarmaContext";
import axios from "axios";

export default function Statustics() {
    const { account, stakcontract, settings, connectWallet, library, esigner, toastSuccess, toastError, copyaddress, ethers, formatAddress, contdata, switchNetwork } = useContext(appContext);
    const [tokenchoice, settokenchoice] = useState(0);
    const [usdt, setusdt] = useState(0);
    const [token, settoken] = useState(0);
    const [trdone, settrdone] = useState(false);
    const [hash, sethash] = useState("");
    const [data, setdata] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [totalExReward, settotalExReward] = useState(0);
    const [totalClaimReward, settotalClaimReward] = useState(0);
    const [totalPendingClaimReward, settotalPendingClaimReward] = useState(0);
    const [dataReferral, setdataReferral] = useState();
    const [totalReferralReward, settotalReferralReward] = useState(0);
    const [totalToken, settotalToken] = useState(0);

    const reloadPage = () => {
        window.location.href = window.location.href;
    };
    const getData = async () => {
        await axios
            .post(process.env.REACT_APP_BACKEND_LINK, {
                method: "transaction",
                submethod: "getbyid",
                address: account,
                page: currentPage,
                pageSize: pageSize,
                key: process.env.REACT_APP_KEY,
            })
            .then((res) => {
                if (res.data.error) {
                    return "";
                }
                setdata(res.data.data);
                console.log("user data--->:", data);

                // Calculate the total of arma_new values
                let totalArmaNew = 0;
                res.data.data.forEach(item => {
                    totalArmaNew += item.arma_new;
                    setTotal(totalArmaNew);
                });

                let totalExtraReward = 0;
                res.data.data.forEach(item => {
                    totalExtraReward += item.extra_reward;
                    settotalExReward(totalExtraReward);
                });
                let totalClaim = 0;
                res.data.data.forEach(item => {
                    totalClaim += item.claim;
                    settotalClaimReward(totalClaim);
                });
                let totalPendingclaim = 0;
                res.data.data.forEach(item => {
                    totalPendingclaim += item.pending_claim;
                    settotalPendingClaimReward(totalPendingclaim);
                });
                console.log("Total of arma_new:", totalArmaNew);
                setPages(Math.ceil(res.data.dataLength / pageSize));
            });
    };

    const getDataReferral = async () => {
        await axios
            .post(process.env.REACT_APP_BACKEND_LINK, {
                method: "referralreward",
                submethod: "getbyid",
                address: account,
                page: currentPage,
                pageSize: pageSize,
                key: process.env.REACT_APP_KEY,
            })
            .then((res) => {
                // var dedata = decryptData(res.data);
                if (res.data.error) {
                    return "";
                }
                setdataReferral(res.data.data);
                console.log("user data1--->:", dataReferral);
                setPages(Math.ceil(res.data.dataLength / pageSize));

                let totalRefreward = 0;
                res.data.data.forEach(item => {
                    totalRefreward += item.referral_rewardd;
                    settotalReferralReward(totalRefreward);
                    console.log("total0", totalRefreward);
                });
            });
    };
    const getDataWithdrawal = async () => {
        await axios
            .post(process.env.REACT_APP_BACKEND_LINK, {
                method: "withdrawal",
                submethod: "getbyid",
                address: account,
                page: currentPage,
                pageSize: pageSize,
                key: process.env.REACT_APP_KEY,
            })
            .then((res) => {
                // var dedata = decryptData(res.data);
                if (res.data.error) {
                    return "";
                }
                setdataReferral(res.data.data);
                console.log("user data1--->:", dataReferral);
                setPages(Math.ceil(res.data.dataLength / pageSize));

                let totalTokenClaim = 0;
                res.data.data.forEach(item => {
                    totalTokenClaim += item.token;
                    settotalToken(totalTokenClaim);
                    console.log("total0123", totalToken);
                });
            });
    };


    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    useEffect(() => {
        // Get the current date
        const currentDate = new Date();

        // Define the target date (July 22, 2024)
        const targetDate = new Date('July 22, 2024');

        // Compare the current date with the target date
        if (currentDate < targetDate) {
            // If the current date is before the target date, disable the button
            setIsButtonDisabled(true);
        } else {
            // If the current date is on or after the target date, enable the button
            setIsButtonDisabled(false);
        }
    }, []); 

    const onDeposit = async () => {
        sethash(null);
        settrdone(true);
        sethash("");
        // switchNetwork(97);

        try {
            // Call your switchNetwork function to change the network
            await switchNetwork(97);
            window.location.reload();
        } catch (error) {
            // Handle any errors that occur during network switching
            console.error('Error switching network:', error);
            toastError("Network switch failed");
            settrdone(false);
            return;
        }
        if (!account) {
            connectWallet();
            toastError("Connect first");
            settrdone(false);
            return;
        }

        let contract = new library.Contract(
            settings.arma_contract,
            JSON.parse(settings.arma_contract_abi),
            esigner
        );

        try {
            var stk = null;
            stk = await contract.withdrawal();
            const receipt = await stk.wait();
            sethash(receipt.transactionHash);
            toastSuccess("Claim done");
            toastSuccess("You will receive AARMA within 5 minutes");

            // Send withdrawal data to backend API
            console.log("YES", receipt.transactionHash);
            await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "withdrawal",
                submethod: "insert",
                key: process.env.REACT_APP_KEY,
                address: account,
                txhash: receipt.transactionHash,
                token: (Number(totalPendingClaimReward) + Number(totalReferralReward)) * 0.10,
            }).then((res) => {
                settoken(0);
                setusdt(0);
                settrdone(false);
                if (res.data.error) {
                    return "";
                }
            });
        } catch (error) {
            toastError("Withdrawal declined");
            settrdone(false);
            return;
        }
    };

    useEffect(() => {
        if (account) {
            getData();
            getDataReferral();
            getDataWithdrawal();
        }
    }, [account, pageSize, currentPage]);

    return (
        <>
            <section className="cyber_arena pt-120 pb-120">
                <div className="container pt-17 pt-sm-20 pt-lg-0">

                    <div className="row">
                        <div className="counter_section__area d-flex align-items-center justify-content-center justify-content-sm-evenly flex-wrap gap-5 br2 p-3 p-sm-6 p-md-8 rounded-20 bg1-color mb-10 mb-md-15">
                            <div className="cyber_arena__item text-center">
                                <div className="cyber_arena__countdown counters d-flex align-items-center justify-content-center">
                                    <span className="odometer hero_area__countdown-number fs-three fw_500" data-odometer-final="4390.13" />
                                    <span className="fs-three fw_500">{total} ARMA</span>
                                </div>
                                <span className="text-center fs-ten">Total </span>
                            </div>
                            <span className="v-line lgx mb-20 pb-6 d-none d-md-block" />
                            <div className="cyber_arena__item text-center">
                                <div className="cyber_arena__countdown counters d-flex align-items-center justify-content-center">
                                    <span className="fs-three fw_500">{totalReferralReward ? totalReferralReward : 0} ARMA</span>
                                    <span className="odometer hero_area__countdown-number fs-three fw_500" data-odometer-final="50,000" />
                                </div>
                                <span className="text-center fs-ten">Referral Reward</span>
                            </div>
                            <span className="v-line lgx mb-20 pb-6 d-none d-md-block" />
                            <div className="cyber_arena__item">
                                <div className="cyber_arena__countdown counters d-flex align-items-center justify-content-center">
                                    <span className="odometer hero_area__countdown-number fs-three fw_500" data-odometer-final="28,751" />
                                    <span className="fs-three fw_500">{totalExReward} ARMA</span>
                                </div>
                                <span className="text-center fs-ten">Presale Bouns (20%)</span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="counter_section__area d-flex align-items-center justify-content-center justify-content-sm-evenly flex-wrap gap-5 br2 p-3 p-sm-6 p-md-8 rounded-20 bg1-color mb-10 mb-md-15">
                            {/* <div className="cyber_arena__item text-center">
                                <div className="cyber_arena__countdown counters d-flex align-items-center justify-content-center">
                                    <span className="odometer hero_area__countdown-number fs-three fw_500" data-odometer-final="4390.13" />
                                    <span className="fs-three fw_500">{totalClaimReward} ARMA</span>
                                </div>
                                <span className="text-center fs-ten">Claim</span>
                            </div>
                            <span className="v-line lgx mb-20 pb-6 d-none d-md-block" /> */}
                            <div className="cyber_arena__item text-center">
                                <div className="cyber_arena__countdown counters d-flex align-items-center justify-content-center">
                                    <span className="fs-three fw_500">{totalPendingClaimReward + totalReferralReward - totalToken} ARMA</span>
                                    <span className="odometer hero_area__countdown-number fs-three fw_500" data-odometer-final="50,000" />
                                </div>
                                <span className="text-center fs-ten">Pending Claim</span>
                            </div>
                            <span className="v-line lgx mb-20 pb-6 d-none d-md-block" />
                            <div className="cyber_arena__item">
                                <div className="cyber_arena__countdown counters d-flex align-items-center justify-content-center">
                                    <span className="fs-three fw_500">{totalToken ? totalToken : 0} ARMA</span>
                                    <span className="odometer hero_area__countdown-number fs-three fw_500" data-odometer-final="28,751" />
                                </div>
                                <span className="text-center fs-ten">Total Claimed</span>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button
                            type="button"
                            className="cmn-btn px-3 px-sm-5 px-md-6 py-3 py-sm-2 d-flex align-items-center gap-1 text-white "
                            onClick={() => { onDeposit() }}
                            disabled={isButtonDisabled}
                        >
                            <span className="p7- fw-semibold d-none d-sm-block">
                                Claim Reward
                            </span>
                        </button>
                    </div>
                </div>
            </section>

        </>
    )
}
